var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8125 21.8135C8.6875 21.9378 8.5 22 8.25 22C8 22 7.8125 21.9378 7.6875 21.8135C2.74997 16.4041 0.25 13.6684 0.187499 13.6062C0.0624988 13.4819 0 13.2953 0 13.0466C0 12.7979 0.0624988 12.6114 0.187499 12.4871L7.6875 4.27979C8.0625 3.90674 8.4375 3.90674 8.8125 4.27979C9.1875 4.65285 9.1875 5.0259 8.8125 5.39896L2.53125 12.3005C2.53125 12.3005 22 12.3005 22.5 12.3005C23 12.3005 23.25 12.5492 23.25 13.0466C23.25 13.544 23 13.7927 22.5 13.7927H2.53125L8.8125 20.6943C9.1875 21.0674 9.1875 21.4404 8.8125 21.8135Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBackArrow);
export default __webpack_public_path__ + "static/media/ico_back_arrow.4cb6210dd072d63943f0c7b316789f09.svg";
export { ForwardRef as ReactComponent };